/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

class ProductDetails extends HTMLElement {
  constructor() {
    super();
    this.detailsTabs = this.querySelectorAll(".details-tab-button");
    this.detailsContentWrappers = this.querySelectorAll(
      ".details-contents-wrapper .details-tab-content"
    );
    this.currentTab = this.querySelector(
      ".details-tab-button.details-tab-opened"
    );
    this.currentContent = this.querySelector(
      ".details-contents-wrapper .details-tab-content.details-tab-content-opened"
    );
  }

  connectedCallback() {
    this.detailsTabs.forEach((tab) => {
      tab.addEventListener("click", this.openTab.bind(this));
    });
  }

  disconnectedCallback() {
    this.detailsTabs.forEach((tab) => {
      tab.removeEventListener("click", this.openTab);
    });
  }

  openTab(ev) {
    const target = ev.currentTarget;
    if (!this.checkTabOpened(target)) {
      this.updateTabOpened(target);
      this.updateContentOpened(target);
    }
  }

  checkTabOpened(target) {
    if (target.classList.contains("details-tab-opened")) {
      return true;
    } else {
      return false;
    }
  }

  updateTabOpened(target) {
    this.currentTab.classList.remove("details-tab-opened");
    this.currentTab = target;
    this.currentTab.classList.add("details-tab-opened");
  }

  updateContentOpened(target) {
    let targetContentSelector = "." + target.dataset.forBlock + "_tab_content";
    this.currentContent.classList.remove("details-tab-content-opened");
    this.currentContent = this.querySelector(targetContentSelector);
    this.currentContent.classList.add("details-tab-content-opened");
  }
}

class ShippingProtection extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("change", this.onChange.bind(this));
    document.addEventListener("cart:change", this.onCartChange.bind(this));
  }

  disconnectedCallback() {
    this.removeEventListener("change", this.onChange.bind(this));
    document.removeEventListener("cart:change", this.onCartChange.bind(this));
  }

  onChange(e) {
    const payload = e.target.checked
      ? { items: [{ id: e.target.value, quantity: 1 }] }
      : { id: e.target.value, quantity: 0 };
    const path = !e.target.checked ? "cart/change.js" : "cart/add.js";

    e.target.disabled = true;
    this.performFetch(payload, path);
  }

  onCartChange(e) {
    const cart = e.detail.cart;
    const firstLineItem = cart.items[0];

    if (firstLineItem.product_type === "Addon" && cart.items.length === 1) {
      this.performFetch(
        { id: firstLineItem.key, quantity: 0 },
        "cart/change.js"
      );
    }
  }

  performFetch(payload, path) {
    fetch(window.Shopify.routes.root + path, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then((response) => {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: true })
        );

        return response.json();
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
}

if (!window.customElements.get("product-details")) {
  window.customElements.define("product-details", ProductDetails);
}

if (!window.customElements.get("shipping-protection")) {
  window.customElements.define("shipping-protection", ShippingProtection);
}
